/**
 * Master Game Data Engine for Parksons Learn To Play
 * Used by learn-to-play-detail-hero.liquid and learn-to-play-detail-content.liquid
 */
window.PARKSONS_GAME_DATA = {
  "poker": {
    "title": "Poker",
    "breadcrumb": "Poker",
    "category": "Poker & Casino",
    "game_type": "Card Games",
    "age": "18+",
    "players": "2–10 Players",
    "pack": "52 Card Deck",
    "hero_image": "shopify://shop_images/Frame_2147225769.svg",
    "objective": "To win the pot by having the highest-ranking hand at showdown or by forcing all other players to fold.",
    "starting": "The dealer shuffles a standard 52-card deck. Depending on the poker variant (e.g. Texas Hold'em, 5-Card Draw), players are dealt initial hole cards and blind bets or antes are placed.",
    "how_to_play": "Players take turns betting through rounds (Pre-flop, Flop, Turn, River). Options on your turn include Check, Bet, Call, Raise, or Fold. Form the best 5-card combination according to standard poker hand rankings.",
    "how_to_play_images": [],
    "strategies": "Patience and position are key. Play strong starting hands, pay attention to opponent betting patterns, and avoid over-bluffing without a solid read."
  },
  "concentration": {
    "title": "Concentration",
    "breadcrumb": "Concentration",
    "category": "Memory",
    "game_type": "Card Games",
    "age": "6+",
    "players": "2+ Players",
    "pack": "52 Card Deck",
    "hero_image": "shopify://shop_images/Frame_2147225769.svg",
    "objective": "To collect pairs of cards of the same rank, such as two fours or two aces.",
    "starting": "Any player shuffles the pack and spreads the cards out, face down on a table or floor in an arrangement that forms a grid, so that no two cards touch or overlap each other.",
    "how_to_play": "Players take turns flipping over two cards at a time, trying to find a matching pair. The first card is left face up until they have turned the second. If they match, the player keeps the pair and gets another turn. If not, both cards are turned face down in place.",
    "how_to_play_images": [],
    "strategies": "A good strategy is to not turn over the card you are sure of first. If you know where a card is, turn over your unknown guess first so if you miss, you retain memory advantage."
  },
  "memory": {
    "title": "Memory",
    "breadcrumb": "Memory",
    "category": "Memory",
    "game_type": "Card Games",
    "age": "6+",
    "players": "2+ Players",
    "pack": "52 Card Deck",
    "hero_image": "shopify://shop_images/Frame_2147225769.svg",
    "objective": "To collect pairs of cards of the same rank, such as two fours or two aces.",
    "starting": "Any player shuffles the pack and spreads the cards out, face down on a table or floor in an arrangement that forms a grid, so that no two cards touch or overlap each other.",
    "how_to_play": "Players take turns flipping over two cards at a time, trying to find a matching pair. The first card is left face up until they have turned the second. If they match, the player keeps the pair and gets another turn. If not, both cards are turned face down in place.",
    "how_to_play_images": [],
    "strategies": "A good strategy is to not turn over the card you are sure of first. If you know where a card is, turn over your unknown guess first so if you miss, you retain memory advantage."
  },
  "three-two-five": {
    "title": "Three-Two-Five",
    "breadcrumb": "Three-Two-Five",
    "category": "Trick Taking",
    "game_type": "Card Games",
    "age": "10+",
    "players": "3 Players",
    "pack": "30 Card Deck",
    "hero_image": "shopify://shop_images/Frame_2147225769.svg",
    "objective": "Three players compete in tricks, aiming to achieve their individual trick target: 3, 2, or 5 tricks.",
    "starting": "Using a 30-card deck (7s through Aces), cards are dealt to 3 players. The dealer has a quota of 2 tricks, the player on dealer's left has 5 tricks (and chooses trump), and the third has 3 tricks.",
    "how_to_play": "Players must follow suit if possible. The highest card of the suit led wins unless a trump card is played. The winner of each trick leads the next.",
    "how_to_play_images": [],
    "strategies": "Trump management is essential. Hold high trumps to capture opponent aces and pull out trumps before leading your side suits."
  },
  "gin-rummy": {
    "title": "Gin Rummy",
    "breadcrumb": "Gin Rummy",
    "category": "Rummy",
    "game_type": "Card Games",
    "age": "10+",
    "players": "2 Players",
    "pack": "52 Card Deck",
    "hero_image": "shopify://shop_images/Frame_2147225769.svg",
    "objective": "Form sets of 3 or 4 cards of the same rank, or runs of 3+ consecutive cards in the same suit, minimizing deadwood points.",
    "starting": "Each player is dealt 10 cards. The remaining deck forms the draw pile, with one card turned face up to start the discard pile.",
    "how_to_play": "On your turn, draw one card from either the draw pile or discard pile, then discard one card. When your unmatched deadwood total is 10 points or less, you may knock to end the round.",
    "how_to_play_images": [],
    "strategies": "Pay close attention to what your opponent draws and discards. Avoid discarding cards that connect with their recent draws."
  },
  "klondike": {
    "title": "Klondike Solitaire",
    "breadcrumb": "Klondike",
    "category": "Solitaire",
    "game_type": "Card Games",
    "age": "8+",
    "players": "1 Player",
    "pack": "52 Card Deck",
    "hero_image": "shopify://shop_images/Frame_2147225769.svg",
    "objective": "Move all 52 cards into four foundation piles sorted by suit in ascending order from Ace to King.",
    "starting": "Deal 28 cards into 7 tableau columns with the top card face up. The rest form the stock pile.",
    "how_to_play": "Build tableau columns downward in alternating red/black colors. Move Aces to foundation slots when revealed. Draw 1 or 3 cards from stock.",
    "how_to_play_images": [],
    "strategies": "Always reveal face-down cards in the tableau first before drawing from the stock pile. Empty spaces can only be filled by Kings."
  },
  "baccarat": {
    "title": "Baccarat",
    "breadcrumb": "Baccarat",
    "category": "Poker & Casino",
    "game_type": "Card Games",
    "age": "18+",
    "players": "2–14 Players",
    "pack": "6 or 8 Decks",
    "hero_image": "shopify://shop_images/Frame_2147225769.svg",
    "objective": "Wager correctly on which hand—Player or Banker—will have a point total closest to 9.",
    "starting": "Two cards are dealt to the Player hand and two to the Banker hand. Tens and face cards count as 0, Aces count as 1.",
    "how_to_play": "If total exceeds 9, the first digit is dropped (e.g. 7+8=15 -> total is 5). A third card may be drawn based on strict fixed Baccarat rules.",
    "how_to_play_images": [],
    "strategies": "The Banker bet mathematically carries a slightly lower house edge than the Player bet, making it a statistical favorite."
  },
  "kings-corner": {
    "title": "Kings Corner",
    "breadcrumb": "Kings Corner",
    "category": "Family Games",
    "game_type": "Card Games",
    "age": "7+",
    "players": "2–4 Players",
    "pack": "52 Card Deck",
    "hero_image": "shopify://shop_images/Frame_2147225769.svg",
    "objective": "Be the first player to play all cards from your hand onto the tableau.",
    "starting": "Deal 7 cards to each player. Place 4 cards face up in North, South, East, West positions around the draw pile. Corner spaces are saved for Kings.",
    "how_to_play": "Draw 1 card per turn. Play cards onto foundation piles in descending numerical order with alternating red and black suits. Kings go into the 4 corner slots.",
    "how_to_play_images": [],
    "strategies": "Clear entire foundation piles into empty spots or corner Kings to open up moves for cards stuck in your hand."
  },
  "texas-holdem-poker": {
    "title": "Texas Hold'em Poker",
    "breadcrumb": "Texas Hold'em",
    "category": "Poker & Casino",
    "game_type": "Card Games",
    "age": "18+",
    "players": "2–10 Players",
    "pack": "52 Card Deck",
    "hero_image": "shopify://shop_images/Frame_2147225769.svg",
    "objective": "Make the best 5-card poker hand using any combination of your 2 hole cards and the 5 community cards.",
    "starting": "Small and Big blinds are posted. Each player receives 2 private hole cards face down.",
    "how_to_play": "Four betting rounds take place: Pre-flop, Flop (first 3 community cards), Turn (4th card), and River (5th card). Highest hand at showdown wins.",
    "how_to_play_images": [],
    "strategies": "Aggression and tight starting hand selection are crucial. Understand table position to control pot sizes."
  },
  "tash": {
    "title": "Tash (Indian Playing Cards)",
    "breadcrumb": "Tash",
    "category": "Traditional",
    "game_type": "Card Games",
    "age": "8+",
    "players": "2–6 Players",
    "pack": "52 Card Deck",
    "hero_image": "shopify://shop_images/Frame_2147225769.svg",
    "objective": "Form valid sequences and sets to empty your hand before opponents.",
    "starting": "Cards are distributed equally among players depending on the variation being played.",
    "how_to_play": "Players turn-by-turn pick and discard cards to complete combinations while trying to hold minimum point penalties.",
    "how_to_play_images": [],
    "strategies": "Keep pure sequences ready early in the game to avoid large penalty scores."
  },
  "war": {
    "title": "War",
    "breadcrumb": "War",
    "category": "Children's Games",
    "game_type": "Card Games",
    "age": "5+",
    "players": "2 Players",
    "pack": "52 Card Deck",
    "hero_image": "shopify://shop_images/Frame_2147225769.svg",
    "objective": "Win all 52 cards in the deck by outranking opponent cards in individual battles.",
    "starting": "Divide the 52-card deck equally between 2 players, kept face down without looking.",
    "how_to_play": "Both players flip their top card simultaneously. The higher rank card wins both. If tied, it's 'WAR': place 3 cards face down, flip the 4th card, winner takes all!",
    "how_to_play_images": [],
    "strategies": "War is a classic game of complete chance, making it ideal for young beginners learning card ranks."
  },
  "mahjong": {
    "title": "Mahjong Cards",
    "breadcrumb": "Mahjong",
    "category": "Tile / Card Games",
    "game_type": "Card Games",
    "age": "12+",
    "players": "4 Players",
    "pack": "144 Card Deck",
    "hero_image": "shopify://shop_images/Frame_2147225769.svg",
    "objective": "Build 4 melds (shungs/pungs/kongs) and 1 pair to declare Mahjong.",
    "starting": "Each player receives 13 cards from the deck.",
    "how_to_play": "Players draw and discard cards in round-robin fashion, claiming discarded cards when completing melds.",
    "how_to_play_images": [],
    "strategies": "Flexibility is essential—keep your hand open to multiple potential meld directions based on discarded cards."
  },
  "whist": {
    "title": "Whist",
    "breadcrumb": "Whist",
    "category": "Trick Taking",
    "game_type": "Card Games",
    "age": "10+",
    "players": "4 Players",
    "pack": "52 Card Deck",
    "hero_image": "shopify://shop_images/Frame_2147225769.svg",
    "objective": "Partnerships score points by winning tricks in excess of 6.",
    "starting": "Four players form two fixed partnerships. All 52 cards are dealt out equally (13 cards each). The last card turned face up determines the trump suit.",
    "how_to_play": "Player to dealer's left leads. Players must follow suit if possible. Highest card of suit led or highest trump wins the trick. Winner leads next.",
    "how_to_play_images": [],
    "strategies": "Track played cards carefully. Signal suit strength to your partner by leading your longest and highest suits."
  },
  "go-fish": {
    "title": "Go Fish",
    "breadcrumb": "Go Fish",
    "category": "Children's Games",
    "game_type": "Card Games",
    "age": "4+",
    "players": "2–6 Players",
    "pack": "52 Card Deck",
    "hero_image": "shopify://shop_images/Frame_2147225769.svg",
    "objective": "Collect the most sets of 4 matching rank cards (books).",
    "starting": "Deal 5 cards to each player (7 cards if 2 players). Place remaining cards face down in the ocean (draw pile).",
    "how_to_play": "Ask a specific player for a rank you hold (e.g. 'Do you have any 4s?'). If they do, they give you all their 4s. If not, they say 'Go Fish!' and you draw from the pile.",
    "how_to_play_images": [],
    "strategies": "Remember what ranks other players ask for on their turns so you know who holds which cards!"
  },
  "bluff": {
    "title": "Bluff / Cheat",
    "breadcrumb": "Bluff",
    "category": "Party Games",
    "game_type": "Card Games",
    "age": "8+",
    "players": "3–10 Players",
    "pack": "52 Card Deck",
    "hero_image": "shopify://shop_images/Frame_2147225769.svg",
    "objective": "Get rid of all your cards by playing them face down while declaring their ranks, whether truthful or bluffing.",
    "starting": "Deal the entire deck equally to all players.",
    "how_to_play": "Play 1–4 cards face down on the stack, announcing their rank in ascending order (Aces, 2s, 3s...). Any player can call 'Bluff!'. If caught bluffing, collect the pile; if innocent, the accuser collects the pile.",
    "how_to_play_images": [],
    "strategies": "Bluff sparingly and with confidence. Call out opponents when their card counts or body language don't add up."
  },
  "bridge": {
    "title": "Contract Bridge",
    "breadcrumb": "Bridge",
    "category": "Trick Taking",
    "game_type": "Card Games",
    "age": "12+",
    "players": "4 Players",
    "pack": "52 Card Deck",
    "hero_image": "shopify://shop_images/Frame_2147225769.svg",
    "objective": "Win the number of tricks specified in the contract established during the bidding phase.",
    "starting": "Four players in 2 partnerships are dealt 13 cards each. A auction bidding phase determines the contract suit and declarer.",
    "how_to_play": "Declarer plays both their own hand and partner's revealed dummy hand. Play follows trick-taking rules: follow suit, highest suit/trump wins.",
    "how_to_play_images": [],
    "strategies": "Master bidding conventions to communicate hand strength accurately with your partner."
  }
};
